import React from 'react';
import classNames from 'classnames';
import { SELECTOR_WIDTH } from './constants';
import Icon from '../icon/components/Icon';
var checkboxClassMapping = {
    CHECKED: 'CheckboxChecked',
    UNCHECKED: 'CheckboxUnchecked',
    PARTIALLY_CHECKED: 'CheckboxPartiallyChecked',
};
var Checkbox = function (_a) {
    var checkboxState = _a.checkboxState;
    return (React.createElement("span", { className: classNames('CheckMark', checkboxClassMapping[checkboxState]) }));
};
var menuItemStyle = function (className, level) {
    var style = {
        paddingLeft: level * 17,
    };
    className === 'SelectAllItem' ? style.width = SELECTOR_WIDTH - 15 : style.width = undefined;
    return style;
};
var MenuItem = function (_a) {
    var item = _a.item, level = _a.level, tooltipId = _a.tooltipId, className = _a.className, onItemToggle = _a.onItemToggle;
    var itemNameWidth = 205 - level * 10;
    var classes = className ? className + " MenuItemListItem" : 'MenuItemListItem';
    return (React.createElement("div", { "data-tip": item.name, "data-for": tooltipId },
        React.createElement("li", { className: classes, onClick: function () { return onItemToggle(item); }, style: menuItemStyle(className, level) },
            React.createElement("div", { className: "MenuItemContainer" },
                React.createElement("div", { className: "CheckboxWrapper" },
                    React.createElement(Checkbox, { checkboxState: item.checkboxState })),
                React.createElement("div", { style: { width: itemNameWidth }, className: "ItemName" }, item.name),
                React.createElement("div", { className: "IconContainer" },
                    React.createElement(Icon, { iconName: item.icon || '', className: "ItemIcon icon disabled cls-1 " + item.iconClass, inverted: item.iconInverted }))))));
};
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map